export const CORE_URLS = {
  GET_USER_DETAILS: "getUserDetails",
  //Login
  REGISTER_USER: "registration",
  LOGIN: "login",
  VERIFY_OTP: "declareOtp",
  LOGOUT: "logout",
  ADD_TRAINING_DOCUMENT: "addTrainingDoc",
  VERIFY_PAYMENT: "payment-verify",
  ADD_UPDATE_NOMINEE: "nominee/save",
  YEARS_OF_PASSING: "get-exam-year",
  CKYC_DATA: "addOCRCkycNo",

  //Menu
  AGENT_MENUS: "agent-menus",
  ADMIN_MENU: "menus",
  STAGE: "stages",
  AGENT_TYPES: "agent-types",
  GET_SINGLE_AGENT_TYPE: "get-single-agent-type",
  GENDERS: "genders",
  SALUTATIONS: "salutations",
  OCCUPATIONS: "occupations",
  CASTE_CATEGORY: "caste-categories",
  MARITAL_STATUS: "marital-statuses",
  CITIES: "cities",
  STATES: "states",
  QUALIFICATION: "qualifications",
  PINCODES: "pincodes",
  UNIVERSITY: "universities",
  BANK_ACCOUNT_TYPES: "bank-account-types",
  INSURER_TYPES: "insurer-types",
  INSURER: "insurers",
  TRANSACTION: "transactionList",
  IFSC: "getIFSCList",

  EXAM_DETAILS: "exam-details/user",

  EXPORT_RESCHEDULE_USER: "exportRescheduleUser",
  GET_EXAM_CENTER: "getExamCenter",
  ADD_UPDATE_EXAM_DETAILS: "createExamDetails",
  USER: "user",

  GET_USER_DATA: "get-agent-details",
  BLACK_LIST_AGENTS: "blacklisted-agents",
  BLACKLISTED_CHECK: "blacklisted-check",

  AGENT_MASTER: "agentMasterList",
  EXPORT_AGENT_MASTER: "export-agent-master",
  CREATE_NEW_AGENT: "leadCreation",
  SAVE_AGENT: "save-agent-type",
  UPLOAD_DOCUMENT: "upload/document",
  AGENT_FINAL_APPROVAL: "userDocumentFinalApproval",

  DISCREPANCY_LIST: "listDiscrepancy",
  TRAINING_DOCUMENTS: "getTrainingDoc",
  DISCREPANCY_ACTIONS: "approvDiscrepancy",
  GET_DISCREPANCY_LISTING: "getDiscrepancy",
  ADD_DISCREPANCY: "createDiscrepancy",

  ADD_UPDATE_PROFILE: "profile/save",
  ADD_UPDATE_BANK_DETAILS: "bank-details/save",
  PAYMENT_RECEIPT_VIEW: "payment-receipt-view",
  AGING_DISCREPANCY: "get-aged-discrepancy",
  USER_TRANSCRIPT_TERMS: "user-transcript-terms",
  CATEGORIES: "categories",
  // Reschedule
  RESCHEDULE_USER: "getRescheduleUser",
  RESCHEDULE_LIST: "getRescheduleList",
  RESCHEDULE_RAISE: "getRescheduleRaise",
  RESCHEDULE_APPROVE: "getRescheduleApprove",
  EXAM_RAISE_USER: "exam-raise/user",
  NOC: "listNoc",

  // Servicing
  GET_ENDORSEMENT_DISCREPANCY_LIST: "getEndorsementDiscrepancyList",

  //Exam-config
  LIST_EXAM_CONFIG: "listExamConfig",
  ADD_UPDATE_EXAM_CONFIG: "addExamConfig",
  GET_EXAM_CONFIG_LIST: "listExamConfig",
  DELETE_EXAM_CONFIG: "deleteExamConfig",
  EXAM_QUESTIONS_LISTING: "listBulkQuestionSet",
  QUE_SET_SAMPLE_EXCEL: "queSetSampleExcel",
  ADD_QUESTION_SET: "addQuestionSet",
  UPDATE_QUESTION_SET: "updateQuestionSet",
  DELETE_QUESTION_SET: "deleteQuestionSet",
};
